export const ANALYTICS_ACTION_TYPES = {
  click: 'click',
  submit: 'submit',
  change: 'change',
  focus: 'focus',
  blur: 'blur',
  scroll: 'scroll',
  resize: 'resize',
  keydown: 'keydown',
  keyup: 'keyup',
  keypress: 'keypress',
  mousemove: 'mousemove',
  mousedown: 'mousedown',
  mouseup: 'mouseup',
  mouseover: 'mouseover',
  mouseout: 'mouseout',
  contextmenu: 'contextmenu',
  touchstart: 'touchstart',
  touchend: 'touchend',
  touchmove: 'touchmove',
  touchcancel: 'touchcancel',
  pointerdown: 'pointerdown',
  pointerup: 'pointerup',
  pointermove: 'pointermove',
  pointercancel: 'pointercancel',
  pointerover: 'pointerover',
  pointerout: 'pointerout',
  pointerenter: 'pointerenter',
  pointerleave: 'pointerleave',
  select: 'select',
  input: 'input',
  reset: 'reset',
  load: 'load',
  unload: 'unload',
  beforeunload: 'beforeunload',
  hashchange: 'hashchange',
  error: 'error',
  abort: 'abort',
  open: 'open',
  message: 'message',
  close: 'close',
  popstate: 'popstate',
  pagehide: 'pagehide',
  visibilitychange: 'visibilitychange',
  copy: 'copy',
  cut: 'cut',
  paste: 'paste',
  drag: 'drag',
  dragstart: 'dragstart',
  dragend: 'dragend',
  gotpointercapture: 'gotpointercapture',
  lostpointercapture: 'lostpointercapture',
  timing: 'timing',
  view: 'view',
  pageView: 'pageView',
  pageLoad: 'pageLoad',
  pageUnload: 'pageUnload',
  pageChange: 'pageChange',
  pageScroll: 'pageScroll',
  pageResize: 'pageResize',
  play: 'play',
  pause: 'pause',
  seek: 'seek',
  skip: 'skip',
  complete: 'complete',
  done: 'done',
  loading: 'loading',
  success: 'success',
  event: 'event',
};
